var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78833 3.06612C3.589 2.86679 3.26582 2.86679 3.06649 3.06612C2.86716 3.26545 2.86716 3.58863 3.06649 3.78795L6.27853 6.99996L3.06649 10.212C2.86716 10.4113 2.86716 10.7345 3.06649 10.9338C3.26582 11.1331 3.589 11.1331 3.78833 10.9338L7.00036 7.72179L10.2123 10.9337C10.4117 11.133 10.7348 11.133 10.9342 10.9337C11.1335 10.7344 11.1335 10.4112 10.9342 10.2119L7.7222 6.99996L10.9342 3.78803C11.1335 3.5887 11.1335 3.26553 10.9342 3.0662C10.7348 2.86687 10.4117 2.86687 10.2123 3.0662L7.00036 6.27813L3.78833 3.06612Z",
    fill: "#D54141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ef44be88bab3b2070cab13a89f07a067.svg";
export { ForwardRef as ReactComponent };